var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "a2a8dac969debb02600eb4f13fd1d9a96bf9a7af"
};